import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, reset } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import { Link } from 'react-router-dom'
import LoadingProgress from '../components/LoadingProgress'
import ErrorMessage from '../components/ErrorMessage'
import { push } from 'react-router-redux'

import { fetchObjective, updateObjective } from '../actions/objectives'
import { fetchCustomers } from '../actions/customers'

import { renderInputField } from '../utils/forms'

import '../styles/ObjectivesAdminView.css'

class ObjectiveEditForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { role, fetchObjective, fetchCustomers, objectives, match } = this.props

    const searchParams = new URLSearchParams(this.props.location.search);
    const year = searchParams.get('year');

    fetchCustomers()

    if (!objectives.objective) {
      fetchObjective(match.params.customer, year)
    } else {
      this.setState({ loaded: true })
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.objectives.objective) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    const searchParams = new URLSearchParams(this.props.location.search);
    const year = searchParams.get('year');

    return this.props.updateObjective(this.props.match.params.customer, year, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  weekFields() {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const monthsES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    return months.map((month, index) => (
      <div key={month} className="obj-edit-month-card">
        <div className="obj-edit-month-header">
          <i className="fas fa-calendar-day"></i> {monthsES[index]}
        </div>
        <div className="obj-edit-month-body">
          {weeks.map(week => (
            <div key={`${month}.${week}`} className="obj-edit-week-row">
              <label className="obj-edit-week-label">{week}</label>
              <Field
                name={`${month}.${week}`}
                component={renderInputField}
                type="number"
              />
            </div>
          ))}
        </div>
      </div>
    ));
  }

  render() {
    const { loaded } = this.state
    const { error, submitting, handleSubmit, customers, role, objectives, pristine, initialValues } = this.props

    if (!loaded || !initialValues) {
      if (objectives.error) {
        return <ErrorMessage message={objectives.error.message} />
      }

      return <LoadingProgress />
    }

    const customerName = objectives.objective.Customer.Fullname;
    const year = (new Date(objectives.objective.TimeStamp)).getFullYear();

    return (
      <div className="objectives-admin-view">
        {/* Header */}
        <div className="obj-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-edit mr-1"></i>
                Editar Objetivos — {customerName} {year}
              </h1>
            </div>
            <div className="header-actions">
              <button className="obj-admin-btn primary" type="submit"
                form="objective-edit-form"
                disabled={pristine || submitting}>
                {submitting
                  ? <><i className="fas fa-spinner fa-spin"></i> Guardando...</>
                  : <><i className="fas fa-save"></i> Guardar</>
                }
              </button>
              <Link to={`/objectives/${objectives.objective.Customer._id}?year=${year}`} className="obj-admin-btn secondary">
                <i className="fas fa-arrow-left"></i>
                <span>Volver</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Form */}
        <form id="objective-edit-form" onSubmit={handleSubmit(this.submit)}>
          <div className="obj-edit-month-grid">
            {this.weekFields()}
          </div>

          {error && <div className="alert alert-danger mt-3">{error}</div>}
        </form>
      </div>
    )
  }
}

ObjectiveEditForm = reduxForm({
  form: 'ObjectiveEditForm',
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/objectives`)
  }
})(ObjectiveEditForm)

const mapStateToProps = state => ({
  customers: state.customers.customers,
  objectives: state.objectives,
  initialValues: state.objectives.objective,
  role: state.auth.role,
})

const mapDispatchToProps = dispatch => ({
  fetchObjective: bindActionCreators(fetchObjective, dispatch),
  updateObjective: bindActionCreators(updateObjective, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  push: bindActionCreators(push, dispatch),
  resetForm: () => dispatch(reset('ObjectiveEditForm')),
})

export default connect(mapStateToProps, mapDispatchToProps)(ObjectiveEditForm)
